/* eslint-disable security/detect-object-injection */
import { ComponentName, HomepageItem, HomepageOrder } from "@fdr/types/ts/Home";

const switchItemsPosition = (
  array: HomepageItem[],
  pos1: number,
  pos2: number
) => {
  const temp = array[pos1];
  array[pos1] = array[pos2];
  array[pos2] = temp;

  return array;
};

export const getNewOrder = (order: HomepageOrder, shouldSwitch: boolean) => {
  const { body } = order;

  if (!body?.length) return order;

  const topRacesIndex = body.findIndex(
    (item) => item.name === ComponentName.TOP_RACES
  );
  const upcomingRacesIndex = body.findIndex(
    (item) => item.name === ComponentName.UPCOMING_RACES
  );

  // If it should switch and upcoming races is below top races
  if (shouldSwitch && upcomingRacesIndex > topRacesIndex) {
    order.body = switchItemsPosition(body, topRacesIndex, upcomingRacesIndex);
  }
  // If it should switch and upcoming races is above top races
  else if (!shouldSwitch && upcomingRacesIndex < topRacesIndex) {
    order.body = switchItemsPosition(body, upcomingRacesIndex, topRacesIndex);
  }

  return order;
};
